<template lang="pug">
  .feature-grid-wrap
    .product-feature-grid(:class='"per-line-"+perLine')
      slot
</template>
<script setup lang="ts">
import { provide, type PropType } from 'vue'

const props = defineProps({
  numbered: {
    type    : Boolean,
    default : true,
  },

  startNumberAt: {
    type    : String,
    default : '1',
  },

  perLine: {
    type    : Number,
    default : 3,
  },
})

provide('productFeatureNumbered', props.numbered)
provide('productFeatureStartNumberAt', props.startNumberAt)

</script>

<style lang='scss'>

.feature-grid-wrap {
  width: 100%;
  overflow: hidden;
}

.product-feature-grid {
  overflow: hidden;
  min-width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-left: -#{$space-xs};
  margin-right: -#{$space-xs};

  > .product-feature {
    padding: $space-xs;
    flex-basis: 100%;
    flex-grow: 0;
  }

  @include not-mobile() {
    > .product-feature {
      flex-basis: 50%;
    }
    @media(min-width: 1441px) {
      &.per-line-3 > .product-feature {
        flex-basis: 33.333%;
      }
      &.per-line-4 > .product-feature {
        flex-basis: 25%;
      }
    }
  }

  @include large-xl() {
    margin-left: -#{$space-s};
    margin-right: -#{$space-s};

    > .product-feature {
      padding: $space-s;
    }
  }
}
</style>